module.exports = "img/create.34f2fb7.png";